import { useState } from 'react';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import * as TopList from 'components/Layout/Tiles/ListContainer';
import { TileContent } from 'components/Layout/PageContainer';
import { Pagination } from '@mui/material';
import { Measure } from 'services/model/model.service';
import { EmptyState } from 'components/EmptyState';
import { MarketplaceInfo } from '../model';

interface TopPerformingMarketplacesProps {
  marketplaces: MarketplaceInfo[];
  isComparisonActive: boolean;
  gmvMeasure: Measure;
  qtyMeasure: Measure;
}

export function TopPerformingMarketplaces({
  marketplaces,
  isComparisonActive,
  gmvMeasure,
  qtyMeasure,
}: TopPerformingMarketplacesProps) {
  const [pageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  if (marketplaces.length === 0) {
    return <EmptyState />;
  }
  return (
    <TileContent className="flex flex-col gap-4 items-center justify-between" data-testid="top-performing-marketplaces">
      <TopList.ListContainer>
        {marketplaces.slice((currentPage - 1) * pageSize, currentPage * pageSize).map(marketplace => (
          <TopList.ListRow key={marketplace.name}>
            {/* Category Column */}
            <TopList.NameCell name={marketplace.name} color={marketplace.color} />
            {/* GMV Column */}
            <TopList.MetricCell
              measure={gmvMeasure}
              value={gmvMeasure.getValue(marketplace.entry.values)}
              comparisonValue={gmvMeasure.getValue(marketplace.entry.compareValues)}
              unit={MeasureUnitCode.CURRENCY}
              comparisonActive={isComparisonActive}
              size="lg"
            />
            {/* Quantity Column */}
            <TopList.MetricCell
              measure={qtyMeasure}
              value={qtyMeasure.getValue(marketplace.entry.values)}
              comparisonValue={qtyMeasure.getValue(marketplace.entry.compareValues)}
              unit={MeasureUnitCode.QUANTITY}
              comparisonActive={isComparisonActive}
            />
          </TopList.ListRow>
        ))}
      </TopList.ListContainer>
      {Math.ceil(marketplaces.length / pageSize) > 1 && (
        <Pagination
          className="mt-4"
          count={Math.ceil(marketplaces.length / pageSize)}
          page={currentPage}
          onChange={(_event, page) => setCurrentPage(page)}
          size="small"
        />
      )}
    </TileContent>
  );
}
